import searches from '@/store/modules/storage/search/searches';
import searchFunctions from '@/store/modules/storage/search/searchFunctions';

export default {
    searches,
    searchFunctions,
};
